import { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';

import { TOAST } from 'constant';
import { toast } from 'layout';
import { mapError } from 'utils/func';

const Confirm = forwardRef(({ refetch }, ref) => {
  // #region Data
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [confirmationControl, setconfirmationControl] = useState(null);
  const { mutate, mode, value } = useMemo(
    () => ({
      mode: confirmationControl?.mode ?? 'delete',
      mutate: confirmationControl?.mutate ?? null,
      value: confirmationControl?.value ?? { id: null },
    }),
    [confirmationControl]
  );

  // #endregion

  // #region Event
  useImperativeHandle(
    ref,
    () => ({
      open: (_confirmationControl) => {
        setconfirmationControl({ ..._confirmationControl });
        setVisible(true);
      },
    }),
    []
  );

  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('organization.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setVisible(false)}
        autoFocus
      />
      <Button
        label={t('organization.ok')}
        className="w-7rem"
        severity="info"
        onClick={() => {
          if (mode !== 'reorder' && !value?.id) return;
          const params = mode !== 'reorder' ? value?.id : value;

          mutate(params, {
            onSuccess: () => {
              toast(TOAST.SUCCESS, t(`organization.${mode}.success`));
              setVisible(false);
              refetch();
            },
            onError: (error) => {
              toast(TOAST.ERROR, mapError(t, error));
            },
          });
        }}
      />
    </div>
  );
  // #endregion

  return (
    <Dialog
      header={<p className="text-blue-500">{t(`organization.${mode}.title`)}</p>}
      visible={visible}
      position="center"
      style={{ width: '400px' }}
      onHide={() => setVisible(false)}
      draggable={false}
      footer={footerConfirmationSubmit}
    >
      <p className="text-lg font-bold">{value?.name}</p>
      <p className="text-lg">{t(`organization.${mode}.confirmationMessage`)}</p>
    </Dialog>
  );
});

export default Confirm;

Confirm.propTypes = {
  refetch: PropTypes.func.isRequired,
};
